import axios from 'axios';
import type {AxiosRequestConfig} from 'axios';
import retryx from "retryx";


// リトライデフォルト設定
const defaultRetryxOptions = {
  maxTries: 3,
  timeout: 30000,
}

/**
 * リトライ機能をもったaxios呼び出し
 * @param {{url: string, data: *}} axiosConfig axios呼び出し設定
 * @param {{maxTries: number, timeout: number}} retryxOptions retryx設定
 *
 * @see https://github.com/axios/axios#request-config
 * @see https://github.com/y13i/retryx#options
 */
export const axiosRetryx = (axiosConfig: AxiosRequestConfig<any>, retryxOptions = defaultRetryxOptions) => {
  return retryx(
    () => (axios(axiosConfig)),
    retryxOptions
  )
}

